module.exports = __webpack_public_path__ + "img/cycle_icon.f42249a5.svg";